import React from 'react';
import { portfolioData } from '../../data/portfolioData';
import './Education.css';

const Education = () => {
  const { education } = portfolioData;

  return (
    <section id="education" className="education section-bg">
      <div className="container">
        <h2>Education</h2>
        <div className="education-timeline">
          {education.map((edu, index) => (
            <div key={index} className="education-item">
              <div className="education-icon">
                <i className="fas fa-graduation-cap"></i>
              </div>
              <div className="education-content">
                <h3>{edu.degree}</h3>
                <div className="institution">{edu.institution}</div>
                <div className="location-period">
                  <span className="location">{edu.location}</span>
                  <span className="period">{edu.period}</span>
                </div>
                {edu.details && <p className="education-details">{edu.details}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;